"use strict";
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { DeviceFormatter } from "@/service/DeviceInfo/deviceFormatter";
import API from "@ym-framework/api-utils";
export class Changeteam {
  static change(team_id, type) {
    return __async(this, null, function* () {
      try {
        let device = yield DeviceFormatter.getInfo();
        let response = yield API.post(`api://base.auth/api/v7/accounts/switchorg/${team_id}`, {
          "device_info": device.device_info,
          "device_mini": device.device_mini,
          "device_name": device.device_name,
          "pin_verify_status": false
        });
        if (response.data.account_pin_verify !== null) {
          yield API.put(`api://base.local/storages/preference/token`, {
            token: response.data.account_session.token
          });
          return {
            type: "pin",
            result: response.data.account_pin_verify
          };
        }
        if (response.data.account_device_permission !== null) {
          if (type === "new") {
          }
          yield API.put(`api://base.local/storages/preference/token`, {
            token: response.data.account_session.token
          });
          return {
            type: "device",
            result: response.data.account_device_permission
          };
        }
        if (type === "new") {
        }
        if (response.data.account_session.marks !== null && response.data.account_session.marks.tags.includes("TEAM_JOIN_ALERT")) {
          localStorage.setItem("showJoinTeamMessage", "true");
        }
        yield API.put(`api://base.local/storages/preference/token`, {
          token: response.data.account_session.token
        });
        return {
          type: "success",
          result: "success"
        };
      } catch (error) {
        let message = {
          type: "error",
          result: ""
        };
        console.log(error);
        if (error.hasOwnProperty("response")) {
          message.result = error.response.data.errors.datas[0].message;
        }
        return message;
      }
    });
  }
}
